import { render, staticRenderFns } from "./privacy_kr.vue?vue&type=template&id=2dac8b4f&"
import script from "./privacy_kr.vue?vue&type=script&lang=js&"
export * from "./privacy_kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports